import store from './core/store';

import {getHomePage} from "./views/home/store/home.slice";
import {getConferenceSettings} from "./core/store/conference.slice";

store.dispatch(getHomePage());
store.dispatch(getConferenceSettings());
